<template>
  <div 
    style="max-width: 500px; height:100%; position: relative; overflow: hidden;" 
    class="Kanit mx-auto bg-subpage">
    <!-- Header -->
    <Header :isHeaderFixed="false"></Header>
    <!-- Content Box -->

    <div class="wrapper-content-box">
      <div class="content-box" style="font-size: 14px;">
        <!-- <p style="font-size: 26px; font-weight: 700;" class="primary--text py-4">สิทธิประโยชน์สมาชิก</p>
        <v-divider style="max-width: 150px;" class="mx-auto"></v-divider> -->
        <div>
          <!-- New -->
          <div class="new-member-wrapper">
            <p style="font-size: 20px;">ระดับสมาชิก*</p>
            <img :src="require('../assets/images/benefit-new-member.png')" width="150px"/>
            <p style="font-size: 18px;" class="pt-2 mb-0">สะสมยอดซื้อ หรือ<br/>ลงทะเบียนครั้งแรก</p>
          </div>
          <v-divider style="max-width: 150px;" class="mx-auto"></v-divider>
          <!-- Silver -->
          <div class="silver-member-wrapper">
            <p style="font-size: 20px;">ระดับสมาชิก*</p>
            <img :src="require('../assets/images/benefit-silver-member.png')" width="150px"/>
            <p style="font-size: 18px;" class="pt-2 mb-0 text-center">
              สะสมยอดซื้อครบ 4,500 บาท<br/>
              ภายในระยะเวลา 1 ปี<br/>
              นับจากวันที่เริ่มสะสมยอดซื้อ หรือ<br/>
              ลงทะเบียนใบรับประกันครั้งแรก
            </p>
            <table class="table-info">
              <tr>
                <td class="head-title">อายุสมาชิก**</td>
                <td class="text-center">1 ปี</td>
              </tr>
              <!-- <tr>
                <td class="head-title">สิทธิ์พิเศษแรกเริ่ม</td>
                <td class="text-center">-</td>
              </tr> -->
              <tr>
                <td class="head-title">สิทธิ์ส่วนลด</td>
                <td class="text-left" style="vertical-align: text-top">
                  สิทธิ์ส่วนลด 100 บาท สำหรับยอดซื้อสินค้าขั้นต่ำ 1,500 บาท จำนวน 3 ครั้ง สำหรับซิ้อสินค้าที่ www.lamy.co.th เท่านั้น
                  </td>
              </tr>
              <tr>
                <td rowspan="2" class="head-title">สิทธิ์พิเศษเดือนเกิด</td>
                <td class="text-left" style="vertical-align: text-top">
                  สิทธิ์ส่วนลด 15% เมื่อซื้อสินค้าครบ 500 บาท ขึ้นไป สำหรับซื้อสินค้าเฉพาะที่ สาขาร้านเมกาบางนา และ ที่ www.lamy.co.th เท่านั้น
                </td>
              </tr>
              <tr>
                <td class="text-left" style="vertical-align: text-top">
                  สิทธิ์แกะสลักฟรี 1 ครั้ง มูลค่า 500 บาท เมื่อซื้อปากกาหรือดินสอ รุ่นใดก็ได้ 1 ด้าม/แท่ง
                </td>
              </tr>
              <!-- <tr>
                <td class="head-title">ของขวัญพิเศษ (Rewards)***</td>
                <td class="text-left" style="vertical-align: text-top">
                  รับฟรี! หมึกซึม Refill รุ่น T10 สีน้ำเงิน จำนวน 1 กล่อง มูลค่า 100 บาท
                </td>
              </tr> -->
              <tr>
                <td class="head-title">สิทธิ์ซื้อสินค้าคอลเลคชั่นใหม่ ก่อนใครที่ www.lamy.co.th</td>
                <td class="text-center">
                  <img :src="require('../assets/images/icon-correct.png')" width="24px"/>
                </td>
              </tr>
              <tr>
                <td class="head-title">สิทธิ์เข้าร่วมกิจกรรมงาน workshop และกิจกรรมต่างๆ</td>
                <td class="text-center">-</td>
              </tr>
            </table>
          </div>
           <v-divider style="max-width: 150px;" class="mx-auto"></v-divider>
           <!-- Gold -->
           <div class="gold-member-wrapper">
            <p style="font-size: 20px;">ระดับสมาชิก*</p>
            <img :src="require('../assets/images/benefit-gold-member.png')" width="150px"/>
            <p style="font-size: 18px;" class="pt-2 mb-0 text-center">
              สะสมยอดซื้อครบ 8,500 บาท<br/>
              ภายในระยะเวลา 1 ปี นับจากวันที่<br/>
              ปรับระดับเป็น Silver Member
            </p>
            <table class="table-info">
              <tr>
                <td class="head-title">อายุสมาชิก**</td>
                <td class="text-center">1 ปี</td>
              </tr>
              <!-- <tr>
                <td class="head-title">สิทธิ์พิเศษแรกเริ่ม</td>
                <td class="text-left">LAMY Welcome Surprise Gift***</td>
              </tr> -->
              <tr>
                <td rowspan="2" class="head-title">สิทธิ์ส่วนลด</td>
                <td class="text-left" style="vertical-align: text-top">
                  สิทธิ์ส่วนลด 100 บาท สำหรับยอดซื้อสินค้าขั้นต่ำ 1,500 บาท จำนวน 5 ครั้ง สำหรับซิ้อสินค้าที่ www.lamy.co.th เท่านั้น
                  </td>
              </tr>
              <tr>
                <td class="text-left" style="vertical-align: text-top">
                  สิทธิ์ส่วนลด 500 บาท สำหรับยอดซื้อสินค้าขั้นต่ำ 4,500 บาท จำนวน 3 ครั้ง สำหรับซิ้อสินค้าที่ www.lamy.co.th เท่านั้น
                </td>
              </tr>
              <tr>
                <td rowspan="2" class="head-title">สิทธิ์พิเศษเดือนเกิด</td>
                <td class="text-left" style="vertical-align: text-top">
                  สิทธิ์ส่วนลด 20% เมื่อซื้อสินค้าครบ 500 บาท ขึ้นไป สำหรับสินค้าเฉพาะที่สาขาเมกาบางนา และ ที่ www.lamy.co.th เท่านั้น
                </td>
              </tr>
              <tr>
                <td class="text-left" style="vertical-align: text-top">
                  สิทธิ์แกะสลักฟรี 1 ครั้ง มูลค่า 500 บาท เมื่อซื้อปากกาหรือดินสอ รุ่นใดก็ได้ 1 ด้าม/แท่ง
                </td>
              </tr>
              <!-- <tr>
                <td class="head-title">ของขวัญพิเศษ (Rewards)***</td>
                <td class="text-left" style="vertical-align: text-top">
                  รับฟรี! ไส้ปากกาโรลเลอร์บอล M63 สีน้ำเงิน 1 ชิ้น มูลค่า 160 บาท
                </td>
              </tr> -->
              <tr>
                <td class="head-title">สิทธิ์ซื้อสินค้าคอลเลคชั่นใหม่ ก่อนใครที่ www.lamy.co.th</td>
                <td class="text-center">
                  <img :src="require('../assets/images/icon-correct.png')" width="24px"/>
                </td>
              </tr>
              <tr>
                <td class="head-title">สิทธิ์เข้าร่วมกิจกรรมงาน workshop และกิจกรรมต่างๆ</td>
                <td class="text-center">
                  <img :src="require('../assets/images/icon-correct.png')" width="24px"/>
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="text-left footer-text">
          <p style="font-weight: 700; font-size: 18px;">เงื่อนไข :</p>
          <p>
            <span style="font-weight: 700; text-decoration: underline;">สาขาที่ร่วมรายการ</span> :
            www.lamy.co.th/ Lamy Concept Store-Pinklao/ Lamy Concept Store One Bangkok / Pop up Mega Bangna/pop up Central World/ Siam Discovery/ Central Chidlom/ Central Bangna/ Central Pinklao/ Central Lardprao/ Siam Paragon/BeTrend Emporium/ The Mall Bangkae/ The Mall Thapra/ The Mall Bangkapi/ The Mall Ngamwongwan/ The Mall Ratchasima/ B2S Central Bangna/ B2S Big C Fashion Island/ B2S Central Ladprao/ B2S Central Chidlom/ B2S Central Pinklao/ B2S Central Rama 3/ B2S Central Rungsit/ B2SCentral Rama 2/ B2S Central World Plaza/ B2S Central Chaengwattana/ B2S Central Plaza Rama 9/ B2S Mega Bangna/ B2S Central Plaza Chiangmai/ B2S CentralPlaza Salaya/ B2S Central Plaza Westgate/ B2S Central Plaza East Ville/ B2S Robinson Chiangmai
          </p>
          <p>*หากมียอดซื้อสะสมไม่ถึงภายในระยะเวลาที่กำหนด ยอดซื้อสะสมทั้งหมดจะถูกยกเลิก</p>
          <p>**<span style="font-weight: 700;">อายุสมาชิก</span> นับจากวันที่ปรับระดับสมาชิก / หลังจากหมดอายุสมาชิก ยอดซื้อสะสมจะถูกเริ่มนับใหม่</p>
          <!-- <p>***<span style="font-weight: 700;">LAMY Welcome Surprise Gift และ ของขวัญพิเศษ (Rewards)</span> สามารถรับได้ที่สาขาที่ร่วมรายการทุกสาขา ยกเว้น www.lamy.co.th</p> -->
          <div>
            <ul>
              <li>การปรับระดับสมาชิก จะแสดงในระบบวันถัดไป เมื่อสะสมยอดซื้อครบตามที่ระบุ</li>
              <li><span style="font-weight: 700;">สิทธิ์ส่วนลด และ สิทธิพิเศษเดือนเกิด</span> ไม่สามารถร่วมกับโปรโมชั่นอื่นได้</li>
              <li><span style="font-weight: 700;">สิทธิพิเศษเดือนเกิด</span> สามารถใช้ได้ภายในเดือนเกิดเท่านั้น</li>
              <li><span style="font-weight: 700;">สิทธิ์แกะสลักในเดือนเกิดฟรี</span> สามารถใช้ได้ที่สาขาที่มีเครื่องแกะสลักเท่านั้น (LAMY SHOP MegaBangna/ Siam Discovery/ Siam Paragon/ B2S Central Ladprao/ B2S Central Plaza Rama 9/ B2S Central World Plaza/ B2S Central Plaza East Ville) ไม่สามารถร่วมกับโปรโมชั่นอื่นได้
              </li>
              <li>สิทธิพิเศษที่ใช้ที่หน้าร้าน ต้องกดใช้สิทธิ์<span style="text-decoration: underline;">ต่อหน้า</span>พนักงานเท่านั้น</li>
            </ul>
          </div>
          
        </div>
      </div>

      <!-- Button -->
      <div class="py-3">
        <v-row>
          <v-col cols="12" class="text-center">
            <v-btn
              tile
              dark
              color="#000"
              @click="changePage(redirectPage)"
              style="width: 100%; height: 48px;"
            >
              <v-icon left>
                mdi-arrow-left 
              </v-icon>
              ย้อนกลับ
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </div>

    
  </div>
</template>

<script>
import Header from "@/components/Header.vue";

export default {
  data() {
    return {
      redirectPage: '',
    }
  },
  components: {
    Header
  },  
  mounted() {
    if(Object.keys(this.member).length == 0) {
      this.redirectPage = 'home';
    } else {
      this.redirectPage = 'profile';
    }
  },
  computed: {
    member() {
      return this.$store.state.member;
    }
  },
  methods: {
    changePage(name) {
      var path = "/"+name;
      if (this.$route.path !== path) {
        this.$router.push({
          path: name,
          query: {...this.$route.query } ,
        }).catch({});
      }
    },
  },
  watch : {
    member(newval,oldval) {
      if(newval != oldval) {
        this.redirectPage = 'profile';
      }
    }
  }

}
</script>

<style lang="scss" scoped>
  .table-info {
    border-collapse: collapse;
    font-size: 13px;
    width: 100%;
    margin-top: 24px;
    tr {
      th {
        padding: 8px;
      }
      td {
        border: 1px solid #999;
        padding: 8px;
      }
      td.head-title {
        text-align: left;
        width: 25%;
      }
    }
  }
  ul {
    li {
      padding-bottom: 12px;
    }
  }
  .new-member-wrapper,
  .silver-member-wrapper,
  .gold-member-wrapper {
    padding: 24px 0;
  }
  .footer-text {
    p {
      margin-bottom: 8px !important;
    }
  }
</style>